import { I as d } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as r, normalizeClass as s, createElementVNode as e } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconMastercard",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(d).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return d[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ e("rect", {
  x: ".25",
  y: "3.75",
  width: "23.5",
  height: "16.5",
  rx: "1.75",
  fill: "#fff",
  stroke: "#E3E5E8",
  "stroke-width": ".5"
}, null, -1), u = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 15.694a4.867 4.867 0 0 1-3.148 1.145C6.172 16.84 4 14.693 4 12.045 4 9.397 6.173 7.25 8.852 7.25c1.201 0 2.3.431 3.148 1.145a4.868 4.868 0 0 1 3.148-1.145c2.68 0 4.852 2.147 4.852 4.795s-2.172 4.794-4.852 4.794c-1.201 0-2.3-.43-3.148-1.145Z",
  fill: "#ED0006"
}, null, -1), f = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 15.694a4.761 4.761 0 0 0 1.705-3.65c0-1.46-.662-2.77-1.705-3.649a4.868 4.868 0 0 1 3.148-1.145c2.68 0 4.852 2.147 4.852 4.795s-2.172 4.794-4.852 4.794c-1.201 0-2.3-.43-3.148-1.145Z",
  fill: "#F9A000"
}, null, -1), h = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 15.694a4.761 4.761 0 0 0 1.705-3.65c0-1.46-.662-2.77-1.705-3.649a4.761 4.761 0 0 0-1.705 3.65c0 1.461.662 2.77 1.705 3.649Z",
  fill: "#FF5E00"
}, null, -1), m = [
  _,
  u,
  f,
  h
];
function p(t, v, i, E, g, a) {
  return r(), l("svg", {
    "aria-label": i.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--mastercard"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Mastercard",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const I = /* @__PURE__ */ n(o, [["render", p]]);
export {
  I as default
};
//# sourceMappingURL=mastercard.js.map
